/* eslint-disable @typescript-eslint/no-explicit-any */

import * as _ from "lodash";
import { Reducer } from "@ctra/utils";

import types from "./types";

/**
 * Higher-order reducer to manipulate things as desired
 */
const hor: (reducer: Reducer<any>) => Reducer<any> = (reducer) => {
  const initialState = reducer(undefined, { type: "__INITIAL__" });

  return (state, action) => {
    const { type, payload } = action;

    /**
     * Non-manipulated state
     */
    const newState = reducer(state, action);

    switch (type) {
      case types.FLUSH: {
        const { keys } = payload;

        return {
          ...newState,
          ..._.reduce(
            keys,
            (acc, key) => {
              acc[key] = initialState[key];

              return acc;
            },
            {} as typeof newState
          )
        };
      }
      default:
        break;
    }

    return newState;
  };
};

export default hor;
